<template>
<div class="bottom-nav">
  <ul class="nav-list">
    <li :class="{active:active==item.id}" v-for="(item,i) in list" :key="i" @click="jumpPage(item.url,item.id!=3)">
      <i class="icon" :class="'icon'+item.id"></i>
      <div>{{item.name}}</div>
    </li>
    <!-- <li :class="{active}">
      <img src="@static/images/nav2.png" alt="">
      <div>产品</div>
    </li>
    <li :class="{active}">
      <img src="@static/images/nav3.png" alt="">
      <div>展业夹</div>
    </li>
    <li :class="{active}">
      <img src="@static/images/nav4.png" alt="">

      <div>我的</div>
    </li> -->
  </ul>
</div>

</template>

<script>
import {common} from "@/api/mixins";
export default {
  mixins: [common],
  data() {
    let userinfo={};
    try {
      userinfo = JSON.parse(localStorage.jzy_user);
    } catch (error) {

    }
    const userId = userinfo.userId;
    return {
      load:false,
      list:[
        {name:"首页",url:"/apps/index",id:"1"},
        {name:"产品",url:"/apps/product",id:"2"},
        {name:"展业",url:"/apps/business/home",id:"5"},
        {name:"订单",url:"/apps/order/index",id:"3"},
        {name:"我的",url:"/apps/my",id:"4"},
      ]
    };
  },
  props: ["active"],
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "./bottomNav.scss"
</style>
